/**
 * Created by filatov on 17.09.2015.
 */
import CostCSVPreviewBaseColumnsStrategy from './CostCSVPreviewBaseColumnsStrategy'

export default function CostCSVPreviewOneLevelsColumnsStrategy() {}

CostCSVPreviewOneLevelsColumnsStrategy.prototype = new CostCSVPreviewBaseColumnsStrategy();

CostCSVPreviewOneLevelsColumnsStrategy.prototype.init = function ({showAverageRates, headerLevelKey, showOthers})
{
    CostCSVPreviewBaseColumnsStrategy.prototype.init.call( this, false, showAverageRates, false);
    this.headerLevelKey = headerLevelKey;
    this.showOthers = showOthers
    return this;
};


CostCSVPreviewOneLevelsColumnsStrategy.prototype.getNumOfDetailsColumns = function ()
{
    return 3;
};


CostCSVPreviewOneLevelsColumnsStrategy.prototype.getCountGroupingRows = function ()
{
    return 1;
};

CostCSVPreviewOneLevelsColumnsStrategy.prototype.addFirstHeaderRowDataCells = function(row) {
    this.addOverallHeaderCells(row)

    const numDataCells = this.showOthers ? this.getNumOfDetailsColumns() - 1 : this.getNumOfDetailsColumns()
    for (let i = 0; i < numDataCells; ++i) {
        this.addCell(row, this.message(this.headerLevelKey))
    }

    if (this.showOthers) this.addCell(row, this.message("report.common.others"))
}







// WEBPACK FOOTER //
// ./web/js/reports/preview/csv/cost/CostCSVPreviewOneLevelsColumnsStrategy.js